/* tokamoka v2 — toplu sepet ve ölçüm
   - Kombinler: "Seti sepete ekle" setteki ürünleri tek istekte sepete ekler
   - Ürün sayfası: "Birlikte iyi gider" işaretlenenleri tek istekte ekler
   - Sepet çekmecesi: "Setini tamamla" / "Yanına bir mini" önerisi (çekmece dosyasına dokunmadan, tarayıcıda eklenir)
   - Ölçüm: eklenen her satıra gizli _tk_kaynak etiketi; hero kullanımı sepete gizli _tk_hero notu olarak düşer;
     aynı olaylar Shopify.analytics.publish ile de yayınlanır (Müşteri etkinlikleri pikseli kurulursa GA4'e gider)
   İndirim yok: fiyat her zaman ürünlerin toplamı. */
(function () {
  'use strict';

  var KEY = '_tk_kaynak';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function $(sel, el) { return (el || document).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }
  function money(cents) {
    var n = Math.round(cents) / 100;
    return n.toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + '₺';
  }
  function track(name, data) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, data || {});
      }
    } catch (e) { /* ölçüm sayfayı asla bozmaz */ }
  }
  function setLabel(btn, text) {
    var l = btn && $('[data-tk-label]', btn);
    if (l) l.textContent = text; else if (btn) btn.textContent = text;
  }
  function busy(btn, on) {
    if (!btn) return;
    btn.classList.toggle('is-busy', on);
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
    if (on) btn.disabled = true;
  }
  function showMsg(el, text) { if (!el) return; el.textContent = text; el.hidden = !text; }
  function friendly(err) {
    var d = err && err.data;
    var t = (d && (d.description || d.message)) || '';
    if (t && typeof t === 'string' && t.length < 160) return t;
    return 'Ürünler sepete eklenemedi. Sayfayı yenileyip tekrar dener misin?';
  }

  /* ---------- sepete toplu ekleme (tek istek) ---------- */
  function sectionsToBundle() {
    var list = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: list } }));
    return list;
  }

  function addItems(items, opts) {
    opts = opts || {};
    var sections = sectionsToBundle();
    var body = { items: items };
    if (sections.length) { body.sections = sections; body.sections_url = window.location.pathname; }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
      .then(function (res) {
        if (!res.ok || (res.data && res.data.status)) {
          var err = new Error('cart'); err.data = res.data; throw err;
        }
        var cart = res.data;
        var S = window.MinimogSettings || {};
        var bus = window.MinimogEvents;
        var theme = window.MinimogTheme;
        if (bus && theme && theme.pubSubEvents && cart.sections) {
          bus.emit(theme.pubSubEvents.cartUpdate, { cart: cart });
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: opts.open !== false } }));
        }
        if (opts.open !== false) {
          var drawer = $('m-cart-drawer');
          if (drawer && S.enable_cart_drawer !== false && typeof drawer.open === 'function') {
            drawer.open();
          } else if (!drawer) {
            window.location.href = (S.routes && S.routes.cart) || (root + 'cart');
          }
        }
        document.dispatchEvent(new CustomEvent('tk:cart:added', { detail: { items: items, source: opts.source || '' } }));
        return cart;
      });
  }

  function props(source) { var p = {}; p[KEY] = source; return p; }

  /* ---------- hero kullanımı ---------- */
  var heroMarked = false;
  function markHero(action, detail) {
    track('tk_hero', { action: action || 'etkilesim', detail: detail || '' });
    if (heroMarked) return;
    heroMarked = true;
    try {
      if (window.sessionStorage.getItem('tk_hero')) return;
      window.sessionStorage.setItem('tk_hero', '1');
    } catch (e) { /* gizli sekme */ }
    fetch(root + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { _tk_hero: 'etkilesim' } })
    }).catch(function () { /* sessiz */ });
  }

  window.tkBundle = { addItems: addItems, markHero: markHero, money: money, track: track, props: props, busy: busy, friendly: friendly };

  /* ---------- Kombinler ---------- */
  function setTotal(card) {
    var sum = 0;
    $$('[data-tk-set-item]', card).forEach(function (li) {
      var price = parseInt(li.getAttribute('data-price'), 10) || 0;
      var sel = $('[data-tk-set-variant]', li);
      if (sel && sel.options[sel.selectedIndex]) price = parseInt(sel.options[sel.selectedIndex].getAttribute('data-price'), 10) || price;
      sum += price;
    });
    var el = $('[data-tk-set-total]', card);
    if (el) el.textContent = money(sum);
  }

  $$('[data-tk-set]').forEach(function (card) {
    var id = card.getAttribute('data-tk-set');
    var btn = $('[data-tk-set-add]', card);
    var msg = $('[data-tk-set-msg]', card);
    $$('[data-tk-set-variant]', card).forEach(function (sel) {
      sel.addEventListener('change', function () {
        setTotal(card);
        setLabel(btn, 'Seti sepete ekle');
        btn.classList.remove('is-done');
      });
    });
    if (!btn) return;
    btn.addEventListener('click', function () {
      var items = $$('[data-tk-set-item]', card).map(function (li) {
        var sel = $('[data-tk-set-variant]', li);
        var vid = sel ? sel.value : li.getAttribute('data-variant-id');
        return { id: parseInt(vid, 10), quantity: 1, properties: props('kombin:' + id) };
      });
      busy(btn, true);
      showMsg(msg, '');
      addItems(items, { source: 'kombin' })
        .then(function () {
          setLabel(btn, 'Sepette');
          btn.classList.add('is-done');
          track('tk_kombin_ekle', { set: id, adet: items.length });
        })
        .catch(function (e) { showMsg(msg, friendly(e)); })
        .then(function () { busy(btn, false); btn.disabled = false; });
    });
  });

  $$('[data-tk-kombinler]').forEach(function (sec) {
    var track_ = $('[data-tk-kombin-track]', sec);
    var prev = $('[data-tk-kombin-prev]', sec);
    var next = $('[data-tk-kombin-next]', sec);
    if (!track_) return;
    function step() {
      var c = $('.tk-kombin', track_);
      return c ? c.getBoundingClientRect().width + 16 : 320;
    }
    function update() {
      if (!prev || !next) return;
      prev.disabled = track_.scrollLeft < 8;
      next.disabled = track_.scrollLeft + track_.clientWidth > track_.scrollWidth - 8;
    }
    if (prev) prev.addEventListener('click', function () { track_.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track_.scrollBy({ left: step(), behavior: 'smooth' }); });
    track_.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* ---------- Ürün sayfası: Birlikte iyi gider ---------- */
  $$('[data-tk-fbt]').forEach(function (box) {
    var btn = $('[data-tk-fbt-add]', box);
    var totalEl = $('[data-tk-fbt-total]', box);
    var countEl = $('[data-tk-fbt-count]', box);
    var msg = $('[data-tk-fbt-msg]', box);
    var self = $('[data-tk-fbt-item][data-self]', box);
    var productRoot = box.closest('[data-tk-product]') || document;
    var product = null;
    try { product = JSON.parse($('[data-tk-product-json]', productRoot).textContent); } catch (e) { product = null; }

    function currentVariant() {
      var inp = $('.tk-buy input[name="id"]', productRoot) || $('input[name="id"]', productRoot);
      if (!product || !inp) return null;
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === String(inp.value)) return product.variants[i];
      }
      return null;
    }

    function sync() {
      var v = currentVariant();
      if (v && self) {
        self.setAttribute('data-variant-id', v.id);
        self.setAttribute('data-price', v.price);
        var lab = $('[data-tk-fbt-self-variant]', box);
        if (lab) lab.textContent = v.title === 'Default Title' ? '' : v.title;
        var pr = $('[data-tk-fbt-self-price]', box);
        if (pr) pr.textContent = money(v.price);
        self.disabled = !v.available;
        if (!v.available) self.checked = false;
      }
      var all = $$('[data-tk-fbt-item]', box);
      var on = all.filter(function (c) { return c.checked && !c.disabled; });
      var sum = on.reduce(function (s, c) { return s + (parseInt(c.getAttribute('data-price'), 10) || 0); }, 0);
      if (totalEl) totalEl.textContent = money(sum);
      if (countEl) countEl.textContent = on.length + ' / ' + all.length + ' seçili';
      var words = ['', 'Seçileni', 'İkisini de', 'Üçünü de'];
      setLabel(btn, on.length === 0 ? 'Ürün seç' : (words[on.length] || 'Hepsini') + ' sepete ekle');
      btn.disabled = on.length === 0;
      all.forEach(function (c) {
        var row = c.closest('.tk-fbt__row');
        if (row) row.classList.toggle('is-off', !c.checked);
      });
    }

    box.addEventListener('change', function (e) {
      if (e.target && e.target.hasAttribute('data-tk-fbt-item')) { showMsg(msg, ''); sync(); }
    });
    $$('.tk-variant', productRoot).forEach(function (b) {
      b.addEventListener('click', function () { setTimeout(sync, 0); });
    });
    btn.addEventListener('click', function () {
      var on = $$('[data-tk-fbt-item]', box).filter(function (c) { return c.checked && !c.disabled; });
      if (!on.length) return;
      var items = on.map(function (c) {
        return { id: parseInt(c.getAttribute('data-variant-id'), 10), quantity: 1, properties: props('birlikte') };
      });
      busy(btn, true);
      showMsg(msg, '');
      addItems(items, { source: 'birlikte' })
        .then(function () { track('tk_birlikte_ekle', { adet: items.length }); })
        .catch(function (e) { showMsg(msg, friendly(e)); })
        .then(function () { busy(btn, false); sync(); });
    });
    sync();
  });
})();
